import Papa from 'papaparse';
import { Product } from '../../../../types';

const useCSVExport = () => {
  const exportToCSV = (products: Product[], storeKey: string, commercialOperationKey?: string) => {
    if (!products?.length) return;

    const fileName = generateExportFilename(storeKey, commercialOperationKey);

    const csv = Papa.unparse(
      products.map((p) => ({
        family: p.family,
        commercialOperationKey: commercialOperationKey ?? '',
        productKey: p.productKey,
        rootCode: p.rootCode,
        name: p.name,
        status: p.status,
        sku: p.sku,
        packaging: p.packaging,
        unitPrice: p.unitPrice,
        stock: p.stock,
        quantity: 0,
      })),
      {
        quotes: true,
        delimiter: ';',
      },
    );

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return { exportToCSV };
};

function generateExportFilename(storeKey: string, commercialOperationKey?: string): string {
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');

  const datePart = [now.getFullYear(), pad(now.getMonth() + 1), pad(now.getDate())].join('-');

  const timePart = [pad(now.getHours()), pad(now.getMinutes()), pad(now.getSeconds())].join('-');

  const commercialOperationKeyPart = commercialOperationKey ? `-${commercialOperationKey}` : '';

  return `Export-catalogue-${storeKey}${commercialOperationKeyPart}-${datePart}-${timePart}.csv`;
}

export default useCSVExport;
